// extracted by mini-css-extract-plugin
module.exports = {"container":"gallery_container__1_R-N","invisible":"gallery_invisible__23liP","floating":"gallery_floating__4l7hT"};